import React, { useState } from "react";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";

export default function CreateRubricForm({ onSuccess, onCancel }) {
  const [category, setCategory] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!category.trim()) {
      setError("Category is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch("/api/brandRatings/brand_rating_rubric", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ category: category.trim() })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to create rubric");
      }

      const newRubric = await response.json();

      onSuccess(newRubric);
      setCategory("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      sx={{
        p: 3,
        mb: 3,
        backgroundColor: "grey.50",
        border: 1,
        borderColor: "grey.300"
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Create New Rubric
      </Typography>

      <TextField
        id="category"
        label="Rubric Name"
        fullWidth
        value={category}
        onChange={(e) => {
          setCategory(e.target.value);
          if (error) {
            setError("");
          }
        }}
        placeholder="e.g., personal_care, home_cleaning"
        disabled={loading}
        error={!!error}
        helperText={error}
        sx={{ mb: 3 }}
      />

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? "Creating..." : "Create Rubric"}
        </Button>
        <Button
          type="button"
          variant="outlined"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
      </Box>
    </Paper>
  );
}
